import { ReactElement } from 'react';
import {
  ActionsContainer,
  ButtonWithMargin,
  ImageContainer,
  ModalImage,
  ResultImage,
} from './styles';
import { DeleteIcon, ZoomInIcon } from '@root/src/assets/images';
import Button from '@root/src/app/designSystem/buttons/index';
import { Modal } from 'react-bootstrap';

type ResultImageContainerI = {
  imageUrl: string;
  alt: string;
  handleRemoveUpload: () => void;
  closePreviewModal: () => void;
  openPreviewModal: () => void;
  setZoomImage: (value: boolean) => void;
  zoomImage: boolean;
  setIsPreviewModalOpened: (value: boolean) => void;
  isPreviewModalOpened: boolean;
  testId?: string;
};

const ResultImageContainer = ({
  imageUrl,
  alt,
  handleRemoveUpload,
  closePreviewModal,
  openPreviewModal,
  setZoomImage,
  zoomImage,
  setIsPreviewModalOpened,
  isPreviewModalOpened,
  testId,
}: ResultImageContainerI): ReactElement => {
  return (
    <>
      <Modal
        data-testid="modal-window-order-preview-image"
        dialogClassName="resultsPreviewFullscreen"
        fullscreen="true"
        onHide={() => setIsPreviewModalOpened(false)}
        show={isPreviewModalOpened}
      >
        <Button type="close" onClick={() => closePreviewModal()} />
        <ModalImage
          onClick={() => setZoomImage(!zoomImage)}
          src={imageUrl}
          zoomImage={zoomImage}
        />
      </Modal>
      <ImageContainer>
        <ResultImage data-testid={testId} src={imageUrl} alt={alt} />
        <ActionsContainer>
          <ButtonWithMargin
            icon={<ZoomInIcon />}
            type="tertiary"
            label="Preview"
            onClick={openPreviewModal}
          />
          <ButtonWithMargin
            icon={<DeleteIcon />}
            type="danger"
            label="Delete"
            onClick={handleRemoveUpload}
          />
        </ActionsContainer>
      </ImageContainer>
    </>
  );
};

export default ResultImageContainer;
